import React, { useEffect, useState } from 'react';
import { Localizer } from 'services/Localizer';
import StarRating from 'shared/components/star-rating/StarRating';
import { dispatchRocEvent } from 'shared/hooks/useRocEventHandler';
import { useProductDetailsContext } from './ProductDetailsContext';
import { ReviewSummaryDto } from './types';
import { warnOnce } from 'util/console';
import { toKebabCase } from 'util/StringUtil';
//#region HCL
import { getUserData } from 'services/UserData';
//#endregion

enum TabType {
	Reviews = 'Reviews',
}

/**
 * Placeholder for product review display
 */
export default function ProductRating() {
	let reviewsSummary: ReviewSummaryDto;
	let displayName: string = '';

	const {
		state: {
			reviewsSummary: standardReviewsSummary,
			productDetails: { tabs },
		},
	} = useProductDetailsContext();

	const hasReviewTab = tabs?.some((tabViewChunk) => tabViewChunk.tab.tabType === TabType.Reviews) === true;

	if (hasReviewTab && tabs) {
		const reviewTabs = tabs.filter((t) => t.tab.tabType === TabType.Reviews);
		reviewsSummary = (reviewTabs[0].model as any).reviewsSummary as ReviewSummaryDto;
		displayName = reviewTabs[0].tab.displayName;
		if (reviewTabs.length > 1) {
			warnOnce('Found more than one product reviews tab!');
		}
	} else {
		reviewsSummary = standardReviewsSummary;
	}

	const { averageRating, reviewCount } = reviewsSummary;

	//#region HCL
	const [userIsSignedIn, setUserIsSignedIn] = useState(false);

	const getUserIsSignedIn = async (): Promise<boolean> => {
		try {
			const data = (await getUserData()).data;
			return (data && data.summary && data.summary.isSignedIn) || false;
		} catch (error) {
			console.error('Unable to load user data', error);
		}
		return Promise.resolve(false);
	};

	useEffect(() => {
		getUserIsSignedIn().then((isSignedIn) => {
			setUserIsSignedIn(isSignedIn);
		});
	}, []);
	//#endregion HCL

	/**
	 * Handle clicking write a review button.
	 */
	function handleBtnClick() {
		dispatchRocEvent('roc-reviews-write-review', {});

		const reviewsTabs = document?.getElementsByClassName('roc-pdp-reviews-listing');

		const reviews = reviewsTabs != null && reviewsTabs.length > 0 ? reviewsTabs[0] : null;

		if (reviews == null || !(reviews instanceof HTMLElement)) {
			return;
		}

		window.scrollTo(0, reviews.offsetTop);
	}

	const rating = Math.round(averageRating ?? 0);

	const reviewText = hasReviewTab ? (
		<>
			<a
				href={`#${toKebabCase(displayName)}`}
				className="roc-pdp-reviews__link"
				data-testid="product-reviews-link"
			>
				{reviewCount}{' '}
				{reviewCount === 0 || reviewCount > 1
					? Localizer('Reviews').toLowerCase()
					: Localizer('Review').toLowerCase()}
			</a>
		</>
	) : (
		<>
			<span>
				{reviewCount}{' '}
				{reviewCount === 0 || reviewCount > 1
					? Localizer('Reviews').toLowerCase()
					: Localizer('Review').toLowerCase()}
			</span>
		</>
	);

	return (
		<div className="roc-pdp-reviews">
			<div className="roc-pdp-reviews__stars">
				<StarRating value={rating} name="top-rating" testId="product-reviews-star-rating" readonly />
			</div>
			<div className="roc-pdp-reviews__links">
				{reviewText}
				{/* //#region HCL */}
				{hasReviewTab && userIsSignedIn ? (
					<>
						<span className="roc-pdp-reviews__link-gap"></span>
						<button
							className="roc-pdp-reviews__link"
							type="button"
							onClick={handleBtnClick}
							data-testid="write-review-link"
						>
							{Localizer('WriteAReview')}
						</button>
					</>
				) : null}
				{/* //#endregion */}
			</div>
		</div>
	);
}
